import React, { useCallback, memo } from 'react';
import Notiflix from 'notiflix';
import {
  Route as RouteDom,
  RouteProps as RoutePropsDom,
  Redirect,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import { getParams } from '../utils/Url';
import { isRouteBlockedForPartialAccess } from './partialAccess';

interface RouteProps extends RoutePropsDom {
  isPrivate?: boolean;
  component: React.ComponentType;
}
const Route: React.FC<RouteProps> = ({
  isPrivate,
  component: Component,
  path,
  ...rest
}) => {
  const { isAuthendicated, isPartialAccess, user, loginJoinIn } = useAuth();
  const redirect = rest.location?.search.split('?redirect=/')[1];
  const params = new URLSearchParams(window.location.search);
  const access = params.get('acesso');

  const joinIn = useCallback(() => {
    const paramsHash = getParams();

    if (paramsHash.hashJoinIn) {
      loginJoinIn(paramsHash.hashJoinIn);
    }
  }, [loginJoinIn]);

  if (path === '/login' && isAuthendicated) {
    joinIn();
    return (
      <RouteDom path={redirect} {...rest}>
        <Redirect to={`/?redirect=${redirect}`} />
      </RouteDom>
    );
  }

  if (
    isPrivate &&
    isAuthendicated &&
    user.mustUpdatePassword === true &&
    path !== '/alterar-senha'
  ) {
    Notiflix.Notify.info(
      'Como é seu primeiro acesso, é necessário alterar senha',
    );

    return (
      <RouteDom path="/alterar-senha" {...rest}>
        <Redirect to="/alterar-senha" />
      </RouteDom>
    );
  }
  if (
    isPrivate &&
    isAuthendicated &&
    isPartialAccess &&
    isRouteBlockedForPartialAccess(
      rest.location?.pathname ?? window.location.pathname,
    )
  ) {
    return (
      <RouteDom path={path} {...rest}>
        <Redirect to="/" />
      </RouteDom>
    );
  }

  return (
    <RouteDom path={path} {...rest}>
      {isPrivate && !isAuthendicated ? (
        <>
          {access !== 'PADIGITAL' ? (
            <Redirect to={`/login?redirect=${path}`} />
          ) : (
            <Redirect to="/login?padigital=true&redirect=/" />
          )}
        </>
      ) : (
        <Component />
      )}
    </RouteDom>
  );
};

export default memo(Route);
